(function () {
  function defineProductModal() {
    if (customElements.get('product-modal') || typeof ModalDialog === 'undefined') return;

    customElements.define('product-modal', class ProductModal extends ModalDialog {
      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        var openedMediaId = this.openedBy && this.openedBy.getAttribute('data-media-id');
        if (!openedMediaId) return;

        this.querySelectorAll('[data-media-id]:not([data-media-id="' + openedMediaId + '"])').forEach(function (element) {
          element.classList.remove('active');
        });

        var activeMedia = this.querySelector('[data-media-id="' + openedMediaId + '"]');
        if (!activeMedia) return;

        var activeMediaTemplate = activeMedia.querySelector('template');
        var activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        var container = this.querySelector('[role="document"]');
        if (container && activeMedia.width) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    });
  }

  function cleanPriceText(root) {
    root.querySelectorAll('.price-item').forEach(function (item) {
      var nodes = Array.prototype.slice.call(item.children);
      nodes.push(item);

      nodes.some(function (node) {
        if (!node.textContent) return false;

        var cleaned = node.textContent.replace(/(\d+)[.,][0]+(?!\d)/g, '$1');
        if (cleaned !== node.textContent) {
          node.textContent = cleaned;
          return true;
        }

        return false;
      });
    });
  }

  function initCustomProductPriceCleanup() {
    var root = document.querySelector('.sp-product');
    if (!root) return;

    cleanPriceText(root);

    if (root.dataset.priceCleanupObserver === 'true') return;
    root.dataset.priceCleanupObserver = 'true';

    var observer = new MutationObserver(function () {
      cleanPriceText(root);
    });

    observer.observe(root, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function getSelectedVariant(root) {
    var variantPicker = root.querySelector('variant-selects, variant-radios');
    if (!variantPicker) return null;

    var selectedVariantScript = variantPicker.querySelector('[data-selected-variant]');
    if (selectedVariantScript && selectedVariantScript.textContent.trim()) {
      try {
        return JSON.parse(selectedVariantScript.textContent);
      } catch (error) {
        return null;
      }
    }

    var variantsScript = variantPicker.querySelector('script[type="application/json"]');
    if (!variantsScript) return null;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      return null;
    }

    var selectedOptions = [];

    root.querySelectorAll('fieldset.product-form__input').forEach(function (fieldset) {
      var checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      if (checkedInput) selectedOptions.push(checkedInput.value);
    });

    root.querySelectorAll('.product-form__input--dropdown select').forEach(function (select) {
      selectedOptions.push(select.value);
    });

    if (!selectedOptions.length) return null;

    return variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    }) || null;
  }

  function syncSubmitButton(root, variant) {
    if (!variant) return;

    var form = root.querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
    var variantInput = form && form.querySelector('input[name="id"]');
    var submitButton = root.querySelector('.product-form__submit');

    if (variantInput && variant.id) {
      variantInput.value = variant.id;
      variantInput.disabled = false;
    }

    if (!submitButton) return;

    var buttonText = submitButton.querySelector('span');

    if (variant.available) {
      submitButton.removeAttribute('disabled');
      submitButton.removeAttribute('aria-disabled');
      submitButton.classList.remove('disabled');

      if (buttonText && window.variantStrings && window.variantStrings.addToCart) {
        buttonText.textContent = window.variantStrings.addToCart;
      }
    } else {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.setAttribute('aria-disabled', 'true');

      if (buttonText && window.variantStrings && window.variantStrings.soldOut) {
        buttonText.textContent = window.variantStrings.soldOut;
      }
    }
  }

  function initVariantSubmitStateSync() {
    var root = document.querySelector('.sp-product');
    if (!root || root.dataset.variantSubmitStateSync === 'true') return;

    root.dataset.variantSubmitStateSync = 'true';

    function scheduleSync(variant) {
      [0, 150, 400].forEach(function (delay) {
        window.setTimeout(function () {
          syncSubmitButton(root, variant || getSelectedVariant(root));
        }, delay);
      });
    }

    root.addEventListener('change', function (event) {
      if (!event.target.matches('input[type="radio"], select')) return;
      scheduleSync();
    });

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data) return;

        var productInfo = root.closest('product-info');
        if (
          productInfo &&
          event.data.sectionId &&
          String(event.data.sectionId) !== String(productInfo.dataset.section)
        ) {
          return;
        }

        scheduleSync(event.data.variant);
      });
    }
  }

  function initCustomProductEnhancements() {
    defineProductModal();
    initCustomProductPriceCleanup();
    initVariantSubmitStateSync();
  }

  defineProductModal();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomProductEnhancements);
  } else {
    initCustomProductEnhancements();
  }

  document.addEventListener('shopify:section:load', initCustomProductEnhancements);
})();
